import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import './PrivacyPage.css';

function PrivacyPage() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Privacy Policy - DocuHounds';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'DocuHounds Privacy Policy - Learn how we protect and handle your academic data with industry-leading security and privacy practices.';

    // Load markdown content
    fetch('/legal/privacy-policy.md')
      .then(res => res.text())
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load privacy policy:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="privacyPage">
        <div className="privacyContainer">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="privacyPage">
      <header className="privacyHero">
        <h1 className="privacyTitle">Privacy Policy</h1>
        <p className="privacyUpdated">Last updated: January 5, 2026</p>
        <p className="privacySubtitle">
          This policy explains how DocuHounds collects, uses, and protects your information.
        </p>
      </header>

      <div className="privacyContainer">
        <div className="card sectionCard">
          <ReactMarkdown
            components={{
              h2: ({ node, children, ...props }) => {
                const id = children?.toString().toLowerCase().replace(/[^\w]+/g, '-');
                return <h2 className="sectionTitle" id={id} {...props}>{children}</h2>;
              },
              h3: ({ node, children, ...props }) => <h3 className="subTitle" {...props}>{children}</h3>,
              ul: ({ node, ...props }) => <ul className="bullets" {...props} />,
              blockquote: ({ node, ...props}) => (
                <div className="box boxInfo" {...props} />
              ),
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
